// The section is fetched once per page and shared by desktop and drawer menus.
let brandMenuRequest;

async function loadBrandMenu(menu) {
  if (!menu || menu.dataset.brandMenuLoaded === 'true' || menu.dataset.brandMenuLoading === 'true') return;

  menu.dataset.brandMenuLoading = 'true';
  const list = menu.querySelector('[data-brand-list]');
  list.setAttribute('aria-busy', 'true');

  try {
    if (!brandMenuRequest) {
      const root = window.Shopify?.routes?.root || '/';
      brandMenuRequest = fetch(`${root}?section_id=brand-menu-content`)
        .then((response) => {
          if (!response.ok) throw new Error(`Brand menu: HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const content = documentFragment.querySelector('.brand-menu-content');
          if (!content) throw new Error('Brand menu content is missing');
          return content;
        })
        .catch((error) => {
          brandMenuRequest = undefined; // Allow a later open to retry.
          throw error;
        });
    }

    const content = await brandMenuRequest;
    if (!menu.isConnected) return;

    list.replaceChildren(...content.querySelector('[data-brand-list-content]').cloneNode(true).childNodes);
    showBrandGroup(menu, menu.dataset.requestedBrandLetter || 'A');
    menu.dataset.brandMenuLoaded = 'true';
  } catch (error) {
    console.error(error);
    list.textContent = 'Brands could not be loaded. Please try again.';
  } finally {
    list.removeAttribute('aria-busy');
    delete menu.dataset.brandMenuLoading;
  }
}

function showBrandGroup(menu, letter) {
  for (const group of menu.querySelectorAll('.brands-group-section')) {
    group.hidden = group.dataset.letter !== letter;
  }
  for (const button of menu.querySelectorAll('.brands-az-nav__link')) {
    const active = button.dataset.letter === letter;
    button.classList.toggle('brands-az-nav__link--active', active);
    if (active) button.setAttribute('aria-current', 'true');
    else button.removeAttribute('aria-current');
  }
  const list = menu.querySelector('[data-brand-list]');
  if (list) list.scrollTop = 0;
}

function menuForTrigger(target) {
  const item = target.closest('.menu-list__list-item, .menu-drawer__list-item');
  return item?.querySelector('[data-brand-menu]');
}

document.addEventListener('pointerover', (event) => {
  const menu = menuForTrigger(event.target);
  if (menu) loadBrandMenu(menu);
});

document.addEventListener('focusin', (event) => {
  const menu = menuForTrigger(event.target);
  if (menu) loadBrandMenu(menu);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('.brands-az-nav__link');
  if (button) {
    const menu = button.closest('[data-brand-menu]');
    if (menu) {
      menu.dataset.requestedBrandLetter = button.dataset.letter;
      showBrandGroup(menu, button.dataset.letter);
      loadBrandMenu(menu);
    }
    return;
  }

  const menu = menuForTrigger(event.target);
  if (menu) loadBrandMenu(menu);
});

// Flat mobile drawers display the brand content without a separate submenu tap.
// Observe only drawer copies so closed desktop submenus never trigger a request.
const drawerBrandObserver = new IntersectionObserver((entries, observer) => {
  for (const entry of entries) {
    if (!entry.isIntersecting || getComputedStyle(entry.target).visibility === 'hidden') continue;
    observer.unobserve(entry.target);
    loadBrandMenu(entry.target);
  }
});

function observeDrawerBrands(root) {
  for (const menu of root.querySelectorAll('header-drawer [data-brand-menu]')) {
    drawerBrandObserver.observe(menu);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => observeDrawerBrands(document), { once: true });
} else {
  observeDrawerBrands(document);
}

// Shopify's theme editor can add or replace the header after initial load.
document.addEventListener('shopify:section:load', (event) => {
  observeDrawerBrands(event.target);
  for (const menu of event.target.querySelectorAll('[data-brand-menu]')) {
    if (menu.matches(':hover, :focus-within')) loadBrandMenu(menu);
  }
});
